
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2014-06-23-delta-rae",
      function () {
        return require("private-next-pages/posts/2014-06-23-delta-rae.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2014-06-23-delta-rae"])
      });
    }
  